import React, { useState, useEffect } from "react";
import Phone from "../../../assets/images/phone.png";
import Store from "../../../assets/images/store.png";

const Advertise = () => {
  const [openModal, setOpenModal] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  useEffect(() => {
    if (openModal) {
      const timer = setTimeout(() => {
        setIsClosing(true); // Start fade-out animation

        setTimeout(() => {
          setOpenModal(false); 
          setIsClosing(false); // Reset fade-out for next time
        }, 300); // Match fade-out duration
      }, 1600);

      return () => clearTimeout(timer);
    }
  }, [openModal]);

  return (
    <section id="contact" className="w-full scroll-mt-[90px] py-20 bg-white font-[inter]">
      <div className="max-w-[1200px] mx-auto px-6">

        <div className="bg-[#6a0dad] rounded-[12px] px-6 md:px-12 py-16 grid md:grid-cols-2 items-center gap-12">

          {/* LEFT — PHONE MOCKUPS */}
          <div className="relative flex justify-center gap-6 pl-20 md:justify-start">
            <img
              src={Phone}
              alt="App Preview"
              className="w-[360px] md:w-[380px] drop-shadow-xl"
            />
          </div>

          {/* RIGHT — TEXT + BUTTONS */}
          <div className="text-white">
            <h2 className="text-[32px] md:text-[36px] font-semibold leading-tight mb-4">
              Download Our App and <br />
              Simplify Your Laundry
            </h2>

            <p className="text-[15px] md:text-[16px] text-[#E6E6E6] leading-relaxed max-w-[460px] mb-8">
              Book, track, and manage your laundry orders anytime, anywhere — all
              from your phone. With our easy-to-use mobile app, you can schedule
              pickups, choose services, make payments, and track delivery in real time.
            </p>

            {/* APP STORE BUTTONS */}
            <div className="flex items-center gap-4">
              <img
                src={Store}
                alt="Store"
                className="w-[280px] cursor-pointer hover:opacity-90 transition"
                onClick={() => setOpenModal(true)}   // 🔥 Added popup trigger
              />
            </div>
          </div>

        </div>

      </div>

      {/* POPUP MODAL */}
      {openModal && (
          <div
            className={`fixed inset-0 z-50 flex items-center justify-center 
            bg-black bg-opacity-50 
            ${isClosing ? "animate-fadeOut" : "animate-fadeIn"}`}
          >
          <div className="bg-white p-6 rounded-lg shadow-lg w-[300px] text-center 
                          animate-slideUp animate-scaleIn">
            <h2 className="mb-3 text-xl font-bold text-gray-800">Coming Soon...</h2>
            <p className="mb-4 text-gray-600">App will be available soon.</p>

            <button
              onClick={() => setOpenModal(false)}
              className="px-4 py-2 text-white transition bg-[#6a0dad] rounded-md hover:bg-[#e2c9faff]"
            >
              OK
            </button>
          </div>
        </div>
      )}

    </section>
  );
};

export default Advertise;
